import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { GetPaymentResultDTO } from '@src/api/@types/GetPaymentResultDTO'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  payment: GetPaymentResultDTO
}

const TablePayment: FC<Props> = ({ payment }) => {
  const { t } = useTranslation()
  const tableData = [
    {
      label: t('calendarTable.status'),
      value:
        payment.status === 0 ? (
          <AccessTimeIcon style={{ color: 'orange', fontSize: '18px' }} />
        ) : payment.status === 1 ? (
          <CheckCircleOutlineIcon style={{ color: 'green', fontSize: '18px' }} />
        ) : (
          <CancelIcon style={{ color: 'red', fontSize: '18px' }} />
        ),
    },
    { label: t('calendarTable.interest'), value: `${payment.plannedInterestAmount} $` },
    { label: t('calendarTable.regularCapital'), value: `${payment.capitalAmount} $` },
    { label: t('calendarTable.nsfFees'), value: `${payment.nsfFee}` },
    { label: t('calendarTable.advanceCapital'), value: `${payment.advancedCapitalAmount} $` },
    { label: t('calendarTable.capitalBalance'), value: `${payment.capitalBalance} $` },
    { label: t('calendarTable.lateAmount'), value: `${payment.lateAmount}` },
    { label: t('calendarTable.loanBalance'), value: `${payment.loanBalance} $` },
  ]

  return ( 
  <TableContainer>
        <Table sx={{ minWidth: 820 }} aria-label="payment table" size="small">
        <TableHead>
        <TableRow>
            <TableCell  sx={{ fontSize: '11px'}} component="th" scope="col">{t('calendarTable.status')}</TableCell>
            <TableCell  sx={{ fontSize: '11px'}} component="th" scope="col">{t('calendarTable.interest')}</TableCell>
            <TableCell  sx={{ fontSize: '10px'}} component="th" scope="col">{t('calendarTable.regularCapital')}</TableCell>
            <TableCell  sx={{ fontSize: '10px'}} component="th" scope="col">{t('calendarTable.nsfFees')}</TableCell>
            <TableCell  sx={{ fontSize: '11px'}} component="th" scope="col">{t('calendarTable.advanceCapital')}</TableCell>
            <TableCell  sx={{ fontSize: '11px'}} component="th" scope="col">{t('calendarTable.capitalBalance')}</TableCell>
            <TableCell  sx={{ fontSize: '11px'}} component="th" scope="col">{t('calendarTable.lateAmount')}</TableCell>
            <TableCell  sx={{ fontSize: '11px'}} component="th" scope="col">{t('calendarTable.loanBalance')}</TableCell>
        </TableRow>
    </TableHead>
      <TableBody>
        <TableRow>
          {tableData.map((data, index) => (
          <TableCell sx={{ fontSize: '12px'}} key={index} data-label={data.label}>
          {data.value}
      </TableCell>
          ))}
        </TableRow>
      </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TablePayment
